// extracted by mini-css-extract-plugin
export default {"search-container":"Bk0QmQ","wrapper-section":"KT288g","wrapper-section__fixed-bottom":"rIUjMM"};